import React from 'react';
import { Flex, Box, Stack, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const ItemSkeleton = () => (
	<Flex gap="space.100" alignItems="center">
		<Box xcss={iconSkeleton} />
		<Box xcss={itemSkeleton} />
	</Flex>
);

export const Skeleton = () => (
	<Stack space="space.300" xcss={containerStyles}>
		<Flex gap="space.100" alignItems="center">
			<Box xcss={backButton} />
			<Box xcss={headingSkeleton} />
		</Flex>
		<Flex gap="space.100" alignItems="center">
			<Box xcss={iconSkeleton} />
			<Box xcss={titleSkeleton} />
		</Flex>
		<Stack space="space.100" grow="hug">
			<ItemSkeleton />
			<ItemSkeleton />
			<ItemSkeleton />
			<ItemSkeleton />
			<ItemSkeleton />
			<ItemSkeleton />
			<ItemSkeleton />
		</Stack>
	</Stack>
);

const containerStyles = xcss({
	paddingBlock: 'space.200',
	paddingInline: 'space.200',
});

const backButton = xcss({
	backgroundColor: 'color.skeleton',
	width: token('space.200'),
	height: token('space.200'),
	borderRadius: 'border.radius.100',
});

const iconSkeleton = xcss({
	backgroundColor: 'color.skeleton',
	width: token('space.300'),
	height: token('space.300'),
	borderRadius: 'border.radius.100',
});

const titleSkeleton = xcss({
	backgroundColor: 'color.skeleton',
	height: token('space.300'),
	width: '50%',
	borderRadius: 'border.radius.100',
});

const headingSkeleton = xcss({
	backgroundColor: 'color.skeleton',
	height: token('space.200'),
	width: token('space.1000'),
	borderRadius: 'border.radius.100',
});

const itemSkeleton = xcss({
	backgroundColor: 'color.skeleton',
	height: token('space.200'),
	borderRadius: 'border.radius.100',
	flex: 1,
});
